<section class="auth">
  <div class="auth__container">
    <router-outlet></router-outlet>
  </div>
</section>
